module.exports = __webpack_public_path__ + "img/bg-front.d7936994.png";